import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withCookies } from 'react-cookie';
import {
    AppBar, Badge, CircularProgress, Dialog, DialogContent, Drawer, IconButton, List, ListItem,
    ListItemAvatar, ListItemText, Menu, MenuItem, Paper, Toolbar, Typography, withStyles,
    SvgIcon,
} from "@material-ui/core";
import {
    Person, Notifications, ExitToApp, CreditCard, History, ViewList, Message, Description
} from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import { logoFull } from '../../resources/images';
import WizzardContainer from '../../containers/content/WizzardContainer';
import AppointmentContent from '../../containers/content/PendingAppointmentsContent';
import CardsContent from '../../containers/content/ManageCards';
import UserEditContent from '../../containers/content/UserEditContent';
import AppointmentHistoryContent from '../../containers/content/AppointmentsHistoryContent';
import TermsContent from '../../containers/content/TermsContent';
import PathError from '../PathError';
import {
    clear_store,
    receive_profile,
    remove_notification,
    notification_viewed,
    remove_generic_notifications
} from "../../apis/redux/fetchActions";
import { loadAptmInProgress } from '../../apis/redux/aptmInProgressActions';
import { loadPaymentPending } from '../../apis/redux/paymentOrderPendingActions';
import AuthService from "../../apis/amplify/AuthService";
import APIService from "../../apis/amplify/APIService";
import { NotificationType } from "../../apis/firebase/notifications/constant";
import ContactUsContent from "../../containers/content/ContactUsContent/ContactUsContent";
import OrderPaymentContent from "../../containers/content/OrderPayment/OrderPaymentContent";
//import TechOnTheWayDialog from "./TechOnTheWayDialog";
import NotificationSlider from "./NotificationSlider";
import If from '../../components/If';
import { styles } from './styles';

const ignoreTabAndShift = fn => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
    }
    fn(event)
}

class MainPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            mobileMoreAnchorEl: null,
            modalVisible: false,
            dense: false,
            secondary: false,
            drawerOpen: false,
            drawerNotificationsOpen: false,
            loading: false,
            detailsDialogOpen: false,
            tabIndex: 0,
            displayArgs: null
        };
    }

    async componentDidMount() {
        const { location } = this.props;
        await this.loadProfile();
        this.props.actions.loadAptmInProgress();
        if (location.pathname !== '/payment-order') {
            this.props.actions.loadPaymentPending();
        }
    }

    async loadProfile() {
        const { ok, data } = await APIService.getProfile();
        if (ok) {
            this.props.actions.receiveProfile(data);
        }
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
        this.handleMobileMenuClose();
    };

    handleMobileMenuOpen = event => {
        this.setState({ mobileMoreAnchorEl: event.currentTarget });
    };

    handleMobileMenuClose = () => {
        this.setState({ mobileMoreAnchorEl: null });
    };

    isMobileMenuOpen() {
        return Boolean(this.state.mobileMoreAnchorEl);
    }

    toggleDrawer = open => event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.setState({
            drawerOpen: open,
        });
    };

    showNotifications = ignoreTabAndShift(() => {
        this.setState({ drawerNotificationsOpen: true })
    });

    hideNotifications = ignoreTabAndShift(() => {
        this.setState({ drawerNotificationsOpen: false });
        this.props.actions.notificationViewed();
        this.props.actions.removeGenericNotifications();
    });

    processNotificationAction = (notification) => {
        if (notification.type === NotificationType.generic) {
            //Generic Notification
        } else if (notification.type === NotificationType.techOnTheWay) {
            this.setState({ detailsDialogOpen: true })
        } else if (notification.type === NotificationType.paymentOrderRequired) {
            this.setState({ orderPaymentNotifId: notification.id });
            this.props.history.push('/payment-order');
        } else if (notification.type === NotificationType.aptmCancelled) {
            this.props.history.push('/appointments-history');
            this.props.actions.removeNotification(notification.id)
        }
        this.hideNotifications();
    };

    switchContent() {
        const pathName = window.location.pathname;
        const isFixScreen = pathName.split("/")[1] === "fix";
        if (isFixScreen) {
            return (<WizzardContainer history={this.props.history}/>);
        }
        else
            switch (pathName) {
                case '/pending-appointments': {
                    return (<AppointmentContent/>);
                }
                case '/appointments-history': {
                    return (<AppointmentHistoryContent/>);
                }
                case '/credit-cards': {
                    return (<CardsContent/>);
                }
                case '/contact-us': {
                    return (<ContactUsContent/>);
                }
                case '/payment-order': {
                    return (<OrderPaymentContent orderPaymentNotifId={this.state.orderPaymentNotifId}/>);
                }
                case '/profile': {
                    return (<UserEditContent/>);
                }
                case '/terms': {
                    return (<TermsContent/>);
                }
                default: {
                    return <PathError redirect={false}/>
                }
            }
    }

    onEditProfile = () => {
        this.props.history.push('/profile');
        this.handleMobileMenuClose()
    };

    onLogOut = () => {
        this.handleMobileMenuClose();
        AuthService.logout().finally(() => {
            this.props.actions.clearStore();
            const { history } = this.props;
            history.push('/login')
        });
    };

    getProfileName() {
        const { profile } = this.props;
        if (profile) {
            return profile.first_name
        }
    }

    goToHome() {
        this.props.history.replace('/fix/devices');
    }


    /*{detailsDialogOpen ?
                    <TechOnTheWayDialog open={detailsDialogOpen}
                                        onClose={() => this.setState({ detailsDialogOpen: false })}
                                        onBackdropClick={() => this.setState({ detailsDialogOpen: false })}/> : null}
    *
    * */

    render() {
        const { classes, profile, notificationsCount, notifications } = this.props;
        const { detailsDialogOpen, drawerNotificationsOpen } = this.state;
        return (
            <Fragment>


                <Dialog open={this.state.loading}>
                    <DialogContent>
                        <Paper elevation={0} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <CircularProgress/>

                            <Typography variant='h6' color={"primary"} style={{ marginTop: '20px' }}>Getting profile
                                information...</Typography>
                        </Paper>
                    </DialogContent>
                </Dialog>

                <AppBar position="fixed" className={classes.appBar}>
                    <Toolbar>
                        <IconButton className={classes.menuButton}
                                    aria-label="Open drawer" style={{ color: 'white' }}
                                    edge="start" onClick={this.toggleDrawer(true)}>
                            <MenuIcon/>
                        </IconButton>
                        <div className={classes.growMovile}/>
                        <img src={logoFull} style={{ width: '130px', cursor: 'pointer', }} alt='Logo'
                             onClick={this.goToHome.bind(this)}/>
                        <div className={classes.grow}/>
                        <div className={classes.sectionDesktop}>
                            <IconButton onClick={this.handleMobileMenuOpen}
                                        disabled={profile === null}
                                        style={{ color: 'white' }}>
                                <Person/>
                                <Typography style={{ marginLeft: '5px', textDecorationLine: 'underline' }}
                                            color='inherit'>
                                    {this.getProfileName()}
                                </Typography>
                            </IconButton>
                            <If as={CircularProgress} condition={!profile} color='secondary' size={20}/>
                        </div>
                        <IconButton onClick={this.showNotifications} style={{ color: 'white' }}>
                            <Badge badgeContent={notificationsCount} color="secondary">
                                <Notifications/>
                            </Badge>
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <Drawer id='drawer' open={this.state.drawerOpen} onClose={this.toggleDrawer(false)}
                        PaperProps={{ className: classes.menuDiv }}>
                    <div className={classes.brandContainer}>
                        <span className="brand">123CellphoneSolutions</span>
                    </div>
                    <List disablePadding={false}>
                        <ListItem button selected={window.location.pathname.split("/")[1] === "fix"}
                                  className={classes.listItem} onClick={() => {
                            this.props.history.push('/fix/devices');
                            this.setState({ drawerOpen: false });
                        }}>
                            <ListItemAvatar>
                                <SvgIcon>
                                    <path id="path1"
                                          transform="rotate(0,12,12) translate(0.0750031471252441,0) scale(0.75,0.75)  "
                                          d="M30.599995,0L31.200001,0.6000061 31.799992,1.1999817 29.700001,5.1000061 27.700001,7.1000061 25.200001,8.6000061 18.200003,15.699982 20.4,17.899994C21.49999,17.199982 22.799993,16.799988 24.200003,16.799988 28.299992,16.799988 31.700001,20.100006 31.700001,24.299988 31.700001,25 31.599995,25.600006 31.399998,26.199982L27.499989,22.299988 23.099997,23.199982 22.200003,27.600006 26.200001,31.5C25.599995,31.699982 24.899998,31.799988 24.299992,31.799988 20.200003,31.799988 16.799993,28.5 16.799993,24.299988 16.799993,23.100006 17.099997,21.899994 17.599997,20.899994L15.299993,18.699982 11.299994,22.699982C11.299994,22.699982 12.4,23.799988 12.9,24.199982 13.299993,24.600006 12.99999,25 12.99999,25L12.4,25.600006C11.999991,26,10.400001,25.600006,10.400001,25.600006L9.4000005,26.600006 4.2999949,31.699982C3.900001,32.100006 2.7000043,32.100006 2.2999949,31.699982 1.9000012,31.299988 1.2999953,30.699982 1.2999954,30.699982 1.2999953,30.699982 0.70000448,30.100006 0.29999541,29.699982 -0.09999847,29.299988 -0.09999847,28.100006 0.29999541,27.699982L5.400001,22.600006 6.4000005,21.600006C6.4000005,21.600006,5.9999919,20,6.4000005,19.600006L6.9999914,19C6.9999914,19,7.4000005,18.600006,7.7999944,19.100006L9.4000005,20.699982 13.4,16.699982 11.099997,14.399994C10.099997,14.899994 8.9000005,15.299988 7.7000036,15.299988 3.599998,15.299988 0.20000454,12 0.20000455,7.7999878 0.20000454,7.1000061 0.29999538,6.5 0.49999236,5.8999939L4.400001,9.7999878 8.7999944,8.8999939 9.7000036,4.5 5.7000041,0.6000061C6.2999944,0.3999939 6.9999914,0.29998779 7.5999975,0.29998779 11.700004,0.29998779 15.099997,3.6000061 15.099997,7.7999878 15.099997,9.1999817 14.700003,10.399994 14.099997,11.600006L16.299993,13.799988 23.299993,6.6999817 24.799992,4.1999817 26.799992,2.1999817z"/>
                                </SvgIcon>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color="secondary" variant='h6'>Fix Devices</Typography>
                            } inset/>
                        </ListItem>
                        <ListItem button selected={window.location.pathname === '/pending-appointments'}
                                  className={classes.listItem} onClick={() => {
                            this.props.history.push('/pending-appointments');
                            this.setState({ drawerOpen: false });
                        }}>
                            <ListItemAvatar>
                                <ViewList/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color="primary" variant='h6'>Pending Appointments</Typography>
                            } inset/>
                        </ListItem>
                        <ListItem button selected={window.location.pathname === '/appointments-history'}
                                  className={classes.listItem} onClick={() => {
                            this.props.history.push('/appointments-history');
                            this.setState({ drawerOpen: false });
                        }}>
                            <ListItemAvatar>
                                <History/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color="primary" variant='h6'>Appointment History</Typography>
                            } inset/>
                        </ListItem>
                        <ListItem button selected={window.location.pathname === '/credit-cards'}
                                  className={classes.listItem}
                                  onClick={() => {
                                      this.props.history.push('/credit-cards');
                                      this.setState({ drawerOpen: false });
                                  }}>
                            <ListItemAvatar>
                                <CreditCard/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color={"primary"} variant='h6'>Manage Cards</Typography>
                            } inset/>
                        </ListItem>
                        <ListItem button selected={window.location.pathname === '/profile'}
                                  className={classes.itemsMobile}
                                  onClick={() => {
                                      this.props.history.push('/profile');
                                      this.setState({ drawerOpen: false });
                                  }}>
                            <ListItemAvatar>
                                <Person/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color={"primary"} variant='h6'>Edit Profile</Typography>
                            } inset/>
                        </ListItem>
                        <ListItem button selected={window.location.pathname === '/contact-us'}
                                  className={classes.listItem}
                                  onClick={() => {
                                      this.props.history.push('/contact-us');
                                      this.setState({ drawerOpen: false });
                                  }}>
                            <ListItemAvatar>
                                <Message/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color={"primary"} variant='h6'>Contact Us</Typography>
                            } inset/>
                        </ListItem>
                        <ListItem button selected={window.location.pathname === '/terms'}
                                  className={classes.listItem}
                                  onClick={() => {
                                      this.props.history.push('/terms');
                                      this.setState({ drawerOpen: false });
                                  }}>
                            <ListItemAvatar>
                                <Description/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color={"primary"} variant='h6'>Terms & Services</Typography>
                            } inset/>
                        </ListItem>

                        <ListItem button className={classes.itemsMobile} onClick={this.onLogOut.bind(this)}>
                            <ListItemAvatar>
                                <ExitToApp/>
                            </ListItemAvatar>
                            <ListItemText primary={
                                <Typography color={"primary"} variant='h6'>Sign out</Typography>
                            } inset/>
                        </ListItem>
                    </List>
                </Drawer>

                <NotificationSlider show={drawerNotificationsOpen}
                                    notifications={notifications}
                                    onClose={this.hideNotifications}
                                    onNotificationClick={this.processNotificationAction}/>

                <Menu
                    anchorEl={this.state.mobileMoreAnchorEl}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={this.isMobileMenuOpen()}
                    onClose={this.handleMenuClose}>
                    <MenuItem onClick={this.onEditProfile}>
                        <Person/>
                        <span>Edit Profile</span>
                    </MenuItem>
                    <MenuItem onClick={this.onLogOut}>
                        <ExitToApp/>
                        <span>Sign out</span>
                    </MenuItem>
                </Menu>


                <div id='content' className={classes.contentDiv}>
                    {this.switchContent()}
                </div>

            </Fragment>
        )
    };

}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        notifications: state.notifications || [],
        notificationsCount: state.notifications.filter(n => n.isNew).length,
    }
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        receiveProfile: receive_profile,
        removeNotification: remove_notification,
        notificationViewed: notification_viewed,
        removeGenericNotifications: remove_generic_notifications,
        loadAptmInProgress,
        loadPaymentPending,
        clearStore: clear_store
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(withStyles(styles, { withTheme: true })(MainPage)));
